import { Api } from 'utils';

class CompanyService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/reports/bills/companies',params),
		create: async (params?: any) => Api.createResponse('admin/reports/bills/companies/create',params),
		delete: async (params?: any) => Api.createResponse('admin/reports/bills/companies/delete',params),
	}

}

export default CompanyService;